var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __await = function(promise, isYieldStar) {
  this[0] = promise;
  this[1] = isYieldStar;
};
var __asyncGenerator = (__this, __arguments, generator) => {
  var resume = (k, v, yes, no) => {
    try {
      var x = generator[k](v), isAwait = (v = x.value) instanceof __await, done = x.done;
      Promise.resolve(isAwait ? v[0] : v).then((y) => isAwait ? resume(k === "return" ? k : "next", v[1] ? { done: y.done, value: y.value } : y, yes, no) : yes({ value: y, done })).catch((e) => resume("throw", e, yes, no));
    } catch (e) {
      no(e);
    }
  }, method = (k, call, wait, clear) => it[k] = (x) => (call = new Promise((yes, no, run) => (run = () => resume(k, x, yes, no), q ? q.then(run) : run())), clear = () => q === wait && (q = 0), q = wait = call.then(clear, clear), call), q, it = {};
  return generator = generator.apply(__this, __arguments), it[__knownSymbol("asyncIterator")] = () => it, method("next"), method("throw"), method("return"), it;
};
var __forAwait = (obj, it, method) => (it = obj[__knownSymbol("asyncIterator")]) ? it.call(obj) : (obj = obj[__knownSymbol("iterator")](), it = {}, method = (key, fn) => (fn = obj[key]) && (it[key] = (arg) => new Promise((yes, no, done) => (arg = fn.call(obj, arg), done = arg.done, Promise.resolve(arg.value).then((value) => yes({ value, done }), no)))), method("next"), method("return"), it);

// src/core/jwt.ts
function decodeJwtPayload(token) {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(base64);
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}
function isTokenExpired(token) {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return true;
  const nowSec = Math.floor(Date.now() / 1e3);
  return payload.exp - nowSec < 60;
}

// src/core/sse.ts
function parseSSE(reader, signal) {
  return __asyncGenerator(this, null, function* () {
    var _a;
    const decoder = new TextDecoder();
    let buffer = "";
    let currentEvent = "";
    let currentData = "";
    while (true) {
      if (signal.aborted) return;
      const { done, value } = yield new __await(reader.read());
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = (_a = lines.pop()) != null ? _a : "";
      for (const line of lines) {
        if (line.startsWith("event: ")) {
          currentEvent = line.slice(7).trim();
        } else if (line.startsWith("data: ")) {
          currentData += (currentData ? "\n" : "") + line.slice(6);
        } else if (line === "") {
          if (currentEvent && currentData) {
            try {
              yield { event: currentEvent, data: JSON.parse(currentData) };
            } catch (e) {
            }
          }
          currentEvent = "";
          currentData = "";
        }
      }
    }
  });
}

// src/core/turn-processor.ts
function createTurn() {
  return {
    reasoningParts: [],
    doneText: void 0,
    metadata: {}
  };
}
var DONE_META_KEYS = [
  "model",
  "usage",
  "credits_used",
  "elapsed_ms",
  "actions",
  "citations",
  "cards",
  "debug_artifacts"
];
function buildDoneMetadata(data, conversationId) {
  const meta = {};
  for (const key of DONE_META_KEYS) {
    if (data[key] !== void 0) meta[key] = data[key];
  }
  meta.conversation_id = conversationId;
  return meta;
}
function processEvent(turn, event, data, conversationId) {
  var _a, _b, _c;
  switch (event) {
    case "status":
      turn.statusText = (_a = data.text) != null ? _a : "";
      break;
    case "debug": {
      const chunks = (_b = data.chunks) != null ? _b : [];
      const plainText = chunks.map((c) => c.replace(/<[^>]*>/g, "")).join("\n");
      if (plainText) {
        turn.reasoningParts.push({ type: "reasoning", text: plainText });
      }
      break;
    }
    case "done":
      turn.doneText = (_c = data.text) != null ? _c : "";
      turn.metadata = buildDoneMetadata(data, conversationId);
      turn.stack = data.stack;
      break;
  }
}
function buildContent(turn, text) {
  var _a;
  return [
    ...turn.reasoningParts,
    { type: "text", text: (_a = text != null ? text : turn.doneText) != null ? _a : "" }
  ];
}

// src/core/config.ts
function detectApiUrl() {
  if (typeof window === "undefined") return "";
  const h = window.location.hostname;
  if (h.includes("readyloop-staging"))
    return "https://auriga.readyloop-staging.dev";
  if (h.includes("readyloop.ai"))
    return "https://auriga.readyloop.ai";
  return "";
}
async function fetchConfig(apiUrl) {
  const resp = await fetch(`${apiUrl}/api/v1/config`);
  if (!resp.ok) {
    throw new Error(`Failed to fetch config: ${resp.status}`);
  }
  return resp.json();
}
async function fetchSbaaConfig(apiUrl, domainOrSlug, options) {
  const param = (options == null ? void 0 : options.bySlug) ? `app=${encodeURIComponent(domainOrSlug)}` : `domain=${encodeURIComponent(domainOrSlug)}`;
  const resp = await fetch(
    `${apiUrl}/api/v1/sbaa/resolve?${param}`
  );
  if (!resp.ok) {
    throw new Error(`Failed to resolve SBAA config: ${resp.status}`);
  }
  return resp.json();
}

// src/core/replay.ts
async function replayConversation(basePath, sessionToken, signal, conversationId) {
  var _a, _b, _c, _d, _e, _f;
  const resp = await fetch(`${basePath}/events?limit=200`, {
    headers: {
      Authorization: `Bearer ${sessionToken}`,
      Accept: "application/json"
    },
    signal
  });
  if (!resp.ok) {
    return [];
  }
  const events = await resp.json();
  const messages = [];
  const requests = /* @__PURE__ */ new Map();
  function getRequest(rid) {
    let r = requests.get(rid);
    if (!r) {
      r = { turn: createTurn() };
      requests.set(rid, r);
    }
    return r;
  }
  for (const ev of events) {
    const rid = (_a = ev.request_id) != null ? _a : "__unknown__";
    if (ev.event === "prompt") {
      getRequest(rid).promptText = (_b = ev.data.text) != null ? _b : "";
    } else {
      processEvent(getRequest(rid).turn, ev.event, ev.data, conversationId);
    }
  }
  let idx = 0;
  let turnNumber = 0;
  for (const [, req] of requests) {
    turnNumber++;
    if (req.promptText !== void 0 && req.promptText.trim() !== "") {
      messages.push({
        role: "user",
        content: [{ type: "text", text: req.promptText }],
        id: `replay-${idx++}`,
        metadata: { custom: { turn_number: turnNumber } }
      });
    }
    if (req.turn.doneText !== void 0) {
      messages.push({
        role: "assistant",
        content: buildContent(req.turn),
        id: `replay-${idx++}`,
        status: { type: "complete", reason: "stop" },
        metadata: { custom: __spreadProps(__spreadValues({}, req.turn.metadata), { turn_number: turnNumber }) }
      });
    }
  }
  const lastCardIndex = /* @__PURE__ */ new Map();
  for (let i = 0; i < messages.length; i++) {
    const cards = (_d = (_c = messages[i].metadata) == null ? void 0 : _c.custom) == null ? void 0 : _d.cards;
    if (cards) {
      for (const c of cards) {
        if (c.card_id) lastCardIndex.set(c.card_id, i);
      }
    }
  }
  for (let i = 0; i < messages.length; i++) {
    const cards = (_f = (_e = messages[i].metadata) == null ? void 0 : _e.custom) == null ? void 0 : _f.cards;
    if (!cards) continue;
    for (const c of cards) {
      if (c.card_id && lastCardIndex.get(c.card_id) !== i && c.buttons) {
        for (const b of c.buttons) {
          b.disabled = true;
        }
      }
    }
  }
  return messages;
}

// src/core/client.ts
var ReadyLoopClient = class {
  constructor(options) {
    this.auth = null;
    this.configCache = null;
    this.apiUrl = options.apiUrl.replace(/\/$/, "");
    this.appKey = options.appKey;
  }
  // ---------------------------------------------------------------------------
  // Auth
  // ---------------------------------------------------------------------------
  setAuth(auth) {
    this.auth = auth;
  }
  getAuth() {
    return this.auth;
  }
  isAuthenticated() {
    return this.auth !== null && !isTokenExpired(this.auth.sessionToken);
  }
  /** Get the Google OAuth login URL. */
  getLoginUrl(origin) {
    var _a, _b;
    const o = encodeURIComponent((_b = origin != null ? origin : (_a = globalThis.location) == null ? void 0 : _a.origin) != null ? _b : "");
    return `${this.apiUrl}/api/v1/auth/google?origin=${o}`;
  }
  /** Exchange an auth code for a session token. */
  async exchangeCode(code) {
    var _a;
    const resp = await fetch(`${this.apiUrl}/api/v1/auth/token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code })
    });
    if (!resp.ok) {
      throw new Error(`Auth exchange failed: ${resp.status}`);
    }
    const data = await resp.json();
    this.auth = {
      sessionToken: (_a = data.session_token) != null ? _a : data.token,
      aurigaUid: data.auriga_uid,
      userEmail: data.email
    };
    return this.auth;
  }
  /** Refresh the session token. Returns false if refresh failed. */
  async refreshToken() {
    if (!this.auth) return false;
    const resp = await fetch(`${this.apiUrl}/api/v1/auth/refresh`, {
      method: "POST",
      headers: this.authHeaders()
    });
    if (!resp.ok) return false;
    const data = await resp.json();
    this.auth = __spreadProps(__spreadValues({}, this.auth), { sessionToken: data.token });
    return true;
  }
  // ---------------------------------------------------------------------------
  // Config
  // ---------------------------------------------------------------------------
  async fetchConfig() {
    if (this.configCache) return this.configCache;
    this.configCache = await fetchConfig(this.apiUrl);
    return this.configCache;
  }
  async fetchSbaaConfig(domain) {
    return fetchSbaaConfig(this.apiUrl, domain);
  }
  // ---------------------------------------------------------------------------
  // Conversations
  // ---------------------------------------------------------------------------
  async createConversation(options = {}) {
    var _a, _b;
    this.requireAuth();
    const body = {
      flow: (_a = options.flow) != null ? _a : this.appKey ? void 0 : "assistant"
    };
    if (options.channelId !== void 0) {
      body.channel_id = (_b = options.channelId) != null ? _b : `web_${this.auth.aurigaUid}`;
    }
    if (options.params) body.params = options.params;
    if (options.depends && options.depends.length > 0) {
      body.depends = options.depends;
    }
    if (this.appKey) body.app_key = this.appKey;
    const resp = await fetch(
      `${this.apiUrl}/api/v1/users/${this.auth.aurigaUid}/conversations`,
      {
        method: "POST",
        headers: this.authHeaders(),
        body: JSON.stringify(body)
      }
    );
    if (!resp.ok) {
      const detail = await resp.text().catch(() => "");
      throw new Error(
        `Failed to create conversation (${resp.status}): ${detail}`
      );
    }
    const data = await resp.json();
    return data.conversation_id;
  }
  // ---------------------------------------------------------------------------
  // Messages + SSE streaming
  // ---------------------------------------------------------------------------
  /**
   * Send a message and stream back SSE events as an async generator.
   */
  sendMessage(conversationId, options) {
    return __asyncGenerator(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g;
      this.requireAuth();
      const basePath = this.conversationPath(conversationId);
      const signal = (_a = options.signal) != null ? _a : new AbortController().signal;
      const postBody = {
        text: options.cardAction ? "" : options.text
      };
      if (options.cardAction) {
        postBody.card_action = options.cardAction;
      }
      const postResp = yield new __await(fetch(`${basePath}/messages`, {
        method: "POST",
        headers: this.authHeaders(),
        body: JSON.stringify(postBody),
        signal
      }));
      if (!postResp.ok) {
        if (postResp.status === 401) {
          throw new Error("Session expired");
        }
        if (postResp.status === 429) {
          const body = yield new __await(postResp.json().catch(() => null));
          const detail = (_b = body == null ? void 0 : body.detail) != null ? _b : {};
          const msg = (_c = typeof detail === "string" ? detail : detail.message) != null ? _c : "Credit limit reached.";
          yield {
            type: "error",
            text: msg,
            content: [{ type: "text", text: msg }],
            metadata: {}
          };
          return;
        }
        const errText = yield new __await(postResp.text());
        throw new Error(
          `POST /messages failed (${postResp.status}): ${errText}`
        );
      }
      const { request_id } = yield new __await(postResp.json());
      const eventsResp = yield new __await(fetch(
        `${basePath}/events?request_id=${request_id}`,
        {
          headers: {
            Authorization: `Bearer ${this.auth.sessionToken}`,
            Accept: "text/event-stream"
          },
          signal
        }
      ));
      if (!eventsResp.ok || !eventsResp.body) {
        if (eventsResp.status === 401) {
          throw new Error("Session expired");
        }
        throw new Error(`GET /events failed (${eventsResp.status})`);
      }
      const reader = eventsResp.body.getReader();
      const turn = createTurn();
      try {
        try {
          for (var iter = __forAwait(parseSSE(reader, signal)), more, temp, error; more = !(temp = yield new __await(iter.next())).done; more = false) {
            const sseEvent = temp.value;
            if (signal.aborted) return;
            processEvent(turn, sseEvent.event, sseEvent.data, conversationId);
            switch (sseEvent.event) {
              case "status":
                yield {
                  type: "status",
                  text: (_d = turn.statusText) != null ? _d : "",
                  content: buildContent(turn, ""),
                  metadata: { status: turn.statusText }
                };
                break;
              case "debug":
                yield {
                  type: "debug",
                  text: "",
                  content: buildContent(turn, ""),
                  metadata: {}
                };
                break;
              case "done":
                yield {
                  type: "done",
                  text: (_e = turn.doneText) != null ? _e : "",
                  content: buildContent(turn),
                  metadata: turn.metadata
                };
                break;
              case "error": {
                const errMsg = (_f = sseEvent.data.message) != null ? _f : "Something went wrong";
                const userMsg = (_g = sseEvent.data.user_message) != null ? _g : "Sorry, something went wrong. Please try again.";
                yield {
                  type: "error",
                  text: userMsg,
                  content: buildContent(turn),
                  metadata: { error: errMsg }
                };
                return;
              }
            }
          }
        } catch (temp) {
          error = [temp];
        } finally {
          try {
            more && (temp = iter.return) && (yield new __await(temp.call(iter)));
          } finally {
            if (error)
              throw error[0];
          }
        }
      } finally {
        reader.cancel();
      }
    });
  }
  // ---------------------------------------------------------------------------
  // Replay
  // ---------------------------------------------------------------------------
  async replayConversation(conversationId, signal) {
    this.requireAuth();
    const basePath = this.conversationPath(conversationId);
    return replayConversation(
      basePath,
      this.auth.sessionToken,
      signal != null ? signal : new AbortController().signal,
      conversationId
    );
  }
  // ---------------------------------------------------------------------------
  // Flows
  // ---------------------------------------------------------------------------
  async fetchFlows() {
    var _a;
    this.requireAuth();
    const resp = await fetch(
      `${this.apiUrl}/api/v1/users/${this.auth.aurigaUid}/flows`,
      { headers: { Authorization: `Bearer ${this.auth.sessionToken}` } }
    );
    if (!resp.ok) return [];
    const data = await resp.json();
    return (_a = data.flows) != null ? _a : [];
  }
  // ---------------------------------------------------------------------------
  // Billing
  // ---------------------------------------------------------------------------
  async getBilling() {
    this.requireAuth();
    const resp = await fetch(
      `${this.apiUrl}/api/v1/users/${this.auth.aurigaUid}/billing`,
      { headers: { Authorization: `Bearer ${this.auth.sessionToken}` } }
    );
    if (!resp.ok) {
      const detail = await resp.text().catch(() => "unknown error");
      throw new Error(`Failed to fetch billing: ${detail}`);
    }
    return resp.json();
  }
  async confirmFreePlan() {
    this.requireAuth();
    const resp = await fetch(
      `${this.apiUrl}/api/v1/users/${this.auth.aurigaUid}/billing/confirm-free`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${this.auth.sessionToken}` }
      }
    );
    if (!resp.ok) {
      const detail = await resp.text().catch(() => "unknown error");
      throw new Error(`Failed to confirm free plan: ${detail}`);
    }
    return resp.json();
  }
  async getPortalUrl() {
    this.requireAuth();
    const resp = await fetch(
      `${this.apiUrl}/api/v1/users/${this.auth.aurigaUid}/billing/portal-session`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${this.auth.sessionToken}` }
      }
    );
    if (!resp.ok) {
      const detail = await resp.text().catch(() => "unknown error");
      throw new Error(`Failed to create portal session: ${detail}`);
    }
    const data = await resp.json();
    return data.url;
  }
  // ---------------------------------------------------------------------------
  // Internals
  // ---------------------------------------------------------------------------
  requireAuth() {
    if (!this.auth) {
      throw new Error("ReadyLoopClient: not authenticated. Call setAuth() or exchangeCode() first.");
    }
  }
  authHeaders() {
    return {
      Authorization: `Bearer ${this.auth.sessionToken}`,
      "Content-Type": "application/json"
    };
  }
  conversationPath(conversationId) {
    return `${this.apiUrl}/api/v1/users/${this.auth.aurigaUid}/conversations/${conversationId}`;
  }
};

// src/core/google-auth.ts
async function openGoogleOAuthPopup(apiUrl, scopeUris) {
  const scopeStr = scopeUris.join(" ");
  const url = `${apiUrl}/api/v1/auth/google/scopes?scopes=${encodeURIComponent(scopeStr)}&incremental=true`;
  return new Promise((resolve) => {
    const width = 600;
    const height = 700;
    const left = window.screenX + (window.innerWidth - width) / 2;
    const top = window.screenY + (window.innerHeight - height) / 2;
    const popup = window.open(
      url,
      "google-oauth-popup",
      `width=${width},height=${height},left=${left},top=${top},popup=true`
    );
    if (!popup) {
      resolve();
      return;
    }
    const timer = setInterval(() => {
      if (popup.closed) {
        clearInterval(timer);
        resolve();
      }
    }, 500);
  });
}

// src/core/drive-picker.ts
var DRIVE_FILE_SCOPE = "https://www.googleapis.com/auth/drive.file";
var pickerReady = null;
function loadPickerApi() {
  if (pickerReady) return pickerReady;
  pickerReady = new Promise((resolve, reject) => {
    if (typeof gapi !== "undefined") {
      gapi.load("picker", resolve);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/api.js";
    script.async = true;
    script.onload = () => gapi.load("picker", resolve);
    script.onerror = () => {
      pickerReady = null;
      reject(new Error("Failed to load Google Picker API"));
    };
    document.head.appendChild(script);
  });
  return pickerReady;
}
async function fetchAccessToken(client) {
  const auth = client.getAuth();
  if (!auth) throw new Error("Client not authenticated");
  const url = `${client.apiUrl}/api/v1/users/${auth.aurigaUid}/auths/google-workspace-user/access-token`;
  const headers = { Authorization: `Bearer ${auth.sessionToken}` };
  const resp = await fetch(url, { headers });
  if (resp.status === 404 || resp.status === 401) {
    await openGoogleOAuthPopup(client.apiUrl, [DRIVE_FILE_SCOPE]);
    const retry = await fetch(url, { headers });
    if (!retry.ok) {
      throw new Error("Google Drive access not available after authorization");
    }
    return retry.json();
  }
  if (!resp.ok) {
    throw new Error(`Failed to get access token (${resp.status})`);
  }
  const data = await resp.json();
  if (!data.scopes.includes("drive.file")) {
    await openGoogleOAuthPopup(client.apiUrl, [DRIVE_FILE_SCOPE]);
    const retry = await fetch(url, { headers });
    if (!retry.ok) {
      throw new Error("Failed to get access token after scope grant");
    }
    return retry.json();
  }
  return data;
}
async function openDrivePicker(client) {
  const [config, tokenData] = await Promise.all([
    client.fetchConfig(),
    fetchAccessToken(client)
  ]);
  await loadPickerApi();
  if (!config.google_picker_api_key || !config.google_cloud_project_number) {
    throw new Error("Google Picker is not configured");
  }
  return new Promise((resolve) => {
    const view = new google.picker.DocsView();
    view.setIncludeFolders(true);
    view.setMode(google.picker.DocsViewMode.LIST);
    const picker = new google.picker.PickerBuilder().setDeveloperKey(config.google_picker_api_key).setAppId(config.google_cloud_project_number).setOAuthToken(tokenData.access_token).addView(view).enableFeature(google.picker.Feature.MULTISELECT_ENABLED).enableFeature(google.picker.Feature.SUPPORT_DRIVES).setTitle("Share files with ReadyLoop").setCallback((data) => {
      var _a;
      const action = data[google.picker.Response.ACTION];
      if (action === google.picker.Action.PICKED) {
        const docs = (_a = data[google.picker.Response.DOCUMENTS]) != null ? _a : [];
        resolve(
          docs.map((doc) => {
            var _a2, _b;
            return {
              id: doc[google.picker.Document.ID],
              name: doc[google.picker.Document.NAME],
              mimeType: doc[google.picker.Document.MIME_TYPE],
              iconUrl: (_a2 = doc[google.picker.Document.ICON_URL]) != null ? _a2 : "",
              url: (_b = doc[google.picker.Document.URL]) != null ? _b : ""
            };
          })
        );
      } else if (action === google.picker.Action.CANCEL) {
        resolve([]);
      }
    }).build();
    picker.setVisible(true);
  });
}

export {
  __spreadValues,
  __spreadProps,
  __objRest,
  __await,
  __asyncGenerator,
  __forAwait,
  decodeJwtPayload,
  isTokenExpired,
  parseSSE,
  createTurn,
  processEvent,
  buildContent,
  detectApiUrl,
  fetchConfig,
  fetchSbaaConfig,
  replayConversation,
  ReadyLoopClient,
  openGoogleOAuthPopup,
  openDrivePicker
};
